import(/* webpackMode: "eager" */ "/codebuild/output/src2430050581/src/app/(dashboard)/page.js");
